<template>
  <div
    class="drone-info-container flexL"
    ref="draggable"
    :style="{
      left: position.x + 'px',
      top: position.y + 'px',
    }"
    @mousedown="startDrag"
  >
    <div
      class="drone-info-container-info"
      v-if="showInfo"
    >
      <div class="header flexL">
        <div class="titles">
          <img
            src="@/assets/img/UAV/无人机参数.png"
            alt="图标"
            class="icon"
          />
          <span>详情</span>
        </div>
        <div @click="showInfo = false">
          <span class="collapse-text">关闭</span>
        </div>
      </div>
      <div
        style="height:720px;padding:10px;width:100%;box-sizing: border-box;justify-content: space-between;overflow: auto;gap: 10px;"
        class="flexColumn"
        v-if="activeTreeItem && activeTreeItem.zruserinfo"
      >
        <div
          class="flexL"
          style="width:100%"
        >
          <div>标题：</div>
          <h3>{{ activeTreeItem ? activeTreeItem.title : "--" }}</h3>
        </div>
        <div
          class="flexL"
          style="width:100%"
        >
          <div>模型：</div>
          <el-select
            v-model="selectModelId"
            size="small"
            placeholder="请选择"
            @change="changeModel"
            filterable
          >
            <el-option
              v-for="item in modelList"
              :key="item.mode01"
              :label="item.mode02"
              :value="item.mode01"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="FCC"
          style="width:100%"
        >
          <div class="FCC">
            <div>状态：</div>
            <div>
              {{
                activeTreeItem
                  ? activeTreeItem.status == 0
                    ? "待回复"
                    : activeTreeItem.status == 1
                    ? "已回复"
                    : "已关闭"
                  : "--"
              }}
            </div>
          </div>
          <div class="FCC">
            <div>责任人：</div>
            <div>
              {{ activeTreeItem ? activeTreeItem.zruserinfo.user04 : "--" }}
            </div>
          </div>
        </div>
        <div
          class="flexL"
          style="width:100%;"
        >
          <div>描述：</div>
          <div style="white-space: normal;">
            {{ activeTreeItem ? activeTreeItem.description : "--" }}
          </div>
        </div>
        <div
          class="flexL"
          style="width:100%"
        >
          <div>视点：</div>
          <el-image
            @click="handleImgClick"
            v-if="activeTreeItem"
            :src="$store.state.baseUrl + activeTreeItem.viewpointinfo.vipo05"
            fit="fill"
            :preview-src-list="[
              $store.state.baseUrl + activeTreeItem.viewpointinfo.vipo05,
            ]"
          >
            <div
              slot="error"
              class="image-slot"
            >
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div
          class="flexL"
          style="width:100%"
        >
          <div>发起人：</div>
          <div>
            {{
              activeTreeItem.creatuserinfo
                ? activeTreeItem.creatuserinfo.user04
                : "--"
            }}
          </div>
        </div>
        <div
          class="flexL"
          style="width:100%"
        >
          <div>发起时间：</div>
          <div>
            {{ activeTreeItem.creattime }}
          </div>
        </div>
        <el-divider><el-link type="primary">回复记录</el-link></el-divider>

        <div style="width:100%;">
          <div
            class="flexColumn"
            style="margin:10px 0;padding:5px;border:1px dashed #00bcd4;gap: 10px;"
            v-for="(item, index) in activeTreeItem.modelreplies"
            :key="index"
          >
            <div
              class="flexColumn"
              style="width:100%;align-items: end;"
            >
              <div
                class="flexL"
                style="width:100%"
              >
                <div>
                  {{
                    item.replayuserinfo ? item.replayuserinfo.user04 : "--"
                  }}：
                </div>
                <div style="white-space: normal;">{{ item.content }}</div>
              </div>

            </div>
            <div
              class="flexL"
              v-if="item.viewinfo &&  typeof item.viewinfo=='object'"
              style="width:100%;margin:0 0 10px 0"
            >
              <div>视点：</div>
              <div
                v-if="item.viewinfo &&  typeof item.viewinfo=='object'"
                class="flexColumn"
              >
                <el-image
                  :preview-src-list="[
             $store.state.baseUrl+item.viewinfo.vipo05,
            ]"
                  :src="$store.state.baseUrl+item.viewinfo.vipo05"
                  fit="fill"
                  :lazy="true"
                ></el-image>
              </div>
            </div>
            <div
              class="flexL"
              v-if="item.files"
              style="width:100%;margin:0 0 10px 0"
            >
              <div>附件：</div>
              <div
                v-if="item.files && item.files.length"
                class="flexColumn"
              >
                <el-link
                  type="primary"
                  @click="openFile(i)"
                  v-for="(i, inx) in item.files.split(',')"
                  :key="inx"
                >附件文件{{ inx + 1
                  }}<i class="el-icon-view el-icon--right"></i>
                </el-link>
              </div>
            </div>
            <div style="text-align: right;width: 100%;">{{ item.creattime }}</div>
          </div>
        </div>

        <div
          class="FCC"
          v-if="activeTreeItem.status != 2"
        >
          <el-button
            type="primary"
            size="small"
            v-if="$store.state.uid != activeTreeItem.creatuserinfo.user01"
            @click="
              replyShow = true;
              GetViewPointList();
            "
          >发起回复</el-button>
          <el-button
            type="primary"
            size="small"
            @click="adminBtn(0)"
            v-if="
              ($store.state.isProject ||
                $store.state.uid == activeTreeItem.creatuserinfo.user01) &&
                activeTreeItem.modelreplies.length
            "
          >驳回问题</el-button>
          <el-button
            type="success"
            size="small"
            @click="adminBtn(2)"
            v-if="
              ($store.state.isProject ||
                $store.state.uid == activeTreeItem.creatuserinfo.user01) &&
                activeTreeItem.modelreplies.length
            "
          >关闭问题</el-button>
        </div>
      </div>
      <el-dialog
        title="回复"
        append-to-body
        :visible.sync="replyShow"
        width="30%"
        @close="
          () => {
            replyForm = $options.data().replyForm;
            $refs.upload.clearFiles();
          }
        "
      >
        <span>
          <el-form
            :model="replyForm"
            ref="form3"
            :rules="replyFormRules"
            label-width="80px"
            :inline="false"
            size="normal"
          >
            <el-form-item
              label="回复内容"
              prop="content"
            >
              <el-input
                v-model="replyForm.content"
                type="textarea"
                :rows="4"
                style="width:100%"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="选择视点"
              prop="viewid"
            >
              <el-cascader
                style="width:100%"
                :options="viewList"
                v-model="replyForm.viewid"
                clearable
                filterable
                :show-all-levels="false"
                :props="{
                  emitPath: false,
                  value: 'vipo01',
                  label: 'vipo02',
                }"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="附件">
              <el-upload
                action="#"
                ref="upload"
                :auto-upload="false"
                multiple
                :limit="5"
                :on-change="
                  (file, fileList) => {
                    replyForm.fileList = fileList.map((item) => item.raw);
                  }
                "
              >
                <el-button
                  slot="trigger"
                  size="small"
                  type="primary"
                >选择附件</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
        </span>
        <span slot="footer">
          <el-button @click="replyShow = false">取消</el-button>
          <el-button
            type="primary"
            @click="clickReply('form3')"
          >回复</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="drone-info-container-list">
      <div
        class="header flexL"
        @click="toggleCollapse"
      >
        <div class="titles">
          <img
            src="@/assets/img/UAV/无人机参数.png"
            alt="图标"
            class="icon"
          />
          <span>问题管理</span>
        </div>
        <div style="width:52px">
          <span class="collapse-text">{{ isCollapsed ? "收起" : "展开" }}</span>
          <i
            class="el-icon-arrow-down"
            v-if="!isCollapsed"
          ></i>
          <i
            class="el-icon-arrow-up"
            v-if="isCollapsed"
          ></i>
        </div>
      </div>
      <transition
        name="slide"
        tag="div"
      >
        <div
          class="content flexColumn"
          v-show="!isCollapsed"
        >
          <div
            class="FCC"
            style="width:100%"
          >
            <el-radio
              v-model="issueType"
              label=""
              @change="GetModelissueList('')"
            >全部</el-radio>
            <el-radio
              v-model="issueType"
              label="0"
              @change="GetModelissueList('')"
            >待回复</el-radio>
            <el-radio
              v-model="issueType"
              label="1"
              @change="GetModelissueList('')"
            >已回复</el-radio>
            <el-radio
              v-model="issueType"
              label="2"
              @change="GetModelissueList('')"
            >已关闭</el-radio>
          </div>
          <el-input
            style="margin:10px 0"
            v-model="issueSearch"
            placeholder="请输入标题关键词搜索"
            @input="GetModelissueList('')"
            size="small"
            clearable
          ></el-input>
          <!-- <div style="height:60px;width:100%;overflow-x:scroll;overflow-y:hidden">
            <div
              class="FCC"
              style="width: fit-content;height: 100%;"
            >
              <div
                v-for="item in userList"
                :key="item.user01"
                class="flexColumn"
                style="margin:0 5px;cursor: pointer;width:70px;height:100%;align-items: center;"
                @click="GetModelissueList(item.user01)"
              >
                <el-image
                  :src="$store.state.baseUrl + item.user13"
                  style="width:30px;height: 30px;"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div
                  class="textEllipsis"
                  style="width:100%;text-align: center;"
                  :title="item.user04"
                >
                  {{ item.user04 }}
                </div>
              </div>
            </div>
          </div> -->
          <zTree
            style="height:80%"
            :zNodes="zNodes"
            @getData="getData"
            @addZtree="addZtree"
            @delZtree="delZtree"
            @EditName="editZtree"
            @rightClick="rightClick"
            :check="false"
            :options="{
              id: 'id',
              label: 'title',
              pid: 'treeid',
              zTreeId: 'hpdc2',
              delType: {
                add: rightItem && rightItem.isfolder == 0 ? false : true,
                update:
                  (rightItem && rightItem.creatuser == $store.state.uid) ||
                  $store.state.isProject,
                del:
                  (rightItem && rightItem.creatuser == $store.state.uid) ||
                  $store.state.isProject,
              },
              drag: false,
            }"
            ref="zTree"
          ></zTree>
          <el-button
            type="primary"
            size="default"
            style="width:100%;;border:none;margin-top:10px"
            :disabled="activeTreeItem == null || activeTreeItem.isfolder == 0"
            @click="
              () => {
                GetViewPointList();
                form = $options.data().form;
                form.treeid = activeTreeItem.id;
                issueShow = true;
              }
            "
          >发起问题</el-button>
        </div>
      </transition>
      <el-dialog
        :title="form.id ? '修改问题' : '发起问题'"
        append-to-body
        :visible.sync="issueShow"
        width="35%"
      >
        <span>
          <el-form
            :model="form"
            ref="form2"
            :rules="rules"
            label-width="90px"
            :inline="false"
            size="normal"
          >
            <el-form-item
              label="标题"
              prop="title"
            >
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item
              label="描述"
              prop="description"
            >
              <el-input
                type="textarea"
                v-model="form.description"
                :rows="6"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="关联视点"
              prop="viewid"
            >
              <el-cascader
                style="width:100%"
                :options="viewList"
                v-model="form.viewid"
                @change="cascaderChange"
                clearable
                filterable
                :show-all-levels="false"
                :props="{
                  emitPath: false,
                  value: 'vipo01',
                  label: 'vipo02',
                }"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item
              label="负责人"
              prop="user"
            >
              <el-select
                style="width:100%"
                v-model="form.user"
                value-key="user01"
                placeholder="请选择"
                clearable
                filterable
              >
                <el-option
                  v-for="item in userList"
                  :key="item.user01"
                  :label="item.user04"
                  :value="item.user01"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </span>
        <span slot="footer">
          <el-button @click="issueShow = false">取消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form2')"
          >确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="form.id ? '修改' : '添加'"
        append-to-body
        :visible.sync="addTreeShow"
        width="35%"
      >
        <span>
          <el-form
            :model="form"
            ref="form"
            :rules="rules"
            label-width="90px"
            :inline="false"
            size="normal"
          >
            <el-form-item
              label="名字"
              prop="title"
            >
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否文件夹" prop="isfolder">
              <el-radio v-model="form.isfolder" :label="0">否</el-radio>
              <el-radio v-model="form.isfolder" :label="1">是</el-radio>
            </el-form-item> -->
          </el-form>
        </span>
        <span slot="footer">
          <el-button @click="addTreeShow = false">取消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form')"
          >确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  GetModelissue,
  GetProjectuser,
  GetViewPoint,
  AddorUpdataModelissue,
  DelModelissue,
  ReplyModelissue,
  GetXtModelVersionsList,
} from "@/setAxios.js";
import zTree from "@/components/zTree.vue";
export default {
  components: {
    zTree,
  },
  props: {
    modelId: {
      type: [Number, String],
      required: true,
      default: () => 0,
    },
  },
  data() {
    return {
      position: { x: 200, y: 20 },
      container: null,
      isDragging: false,
      modelList: [],
      selectModelId: "",
      isCollapsed: false, // 控制面板展开/收起状态
      issueType: "",
      issueSearch: "",
      zNodes: [],
      userList: [],
      viewList: [],
      ysviewList: [],
      yszNodes: [],
      issueShow: false,
      addTreeShow: false,
      replyShow: false,
      form: {
        id: 0,
        xid: null,
        modelId: "",
        treeid: "",
        title: null,
        user: "",
        description: null,
        viewid: null,
        status: 0,
        creatuser: null,
        creattime: null,
        isfolder: 0,
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" },
        ],
        user: [{ required: true, message: "请选择负责人", trigger: "change" }],
        viewid: [{ required: true, message: "请选择视点", trigger: "blur" }],
      },
      replyForm: {
        content: "",
        viewid: "",
        fileList: [],
      },
      replyFormRules: {
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        // viewid: [{ required: true, message: "请选择视点", trigger: "change" }],
      },
      activeTreeItem: null,
      showInfo: false,
      rightItem: null,
    };
  },
  methods: {
    rightClick(data) {
      this.rightItem = data;
    },
    startDrag(e) {
      e.preventDefault();
      this.isDragging = true;

      const el = this.$refs.draggable;
      const rect = el.getBoundingClientRect();
      const containerRect = this.container.getBoundingClientRect();
      
      let startX = e.clientX - rect.left;
      let startY = e.clientY - rect.top;

      const onMouseMove = (e) => {
        if (!this.isDragging) return;

        let newX = e.clientX - containerRect.left - startX;
        let newY = e.clientY - containerRect.top - startY;

        // 限制在容器范围内
        const maxX = containerRect.width - rect.width;
        const maxY = containerRect.height - rect.height;

        newX = Math.max(0, Math.min(newX, maxX));
        newY = Math.max(0, Math.min(newY, maxY));

        this.position = {
          x: newX,
          y: newY,
        };
      };
      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    handleImgClick() {
      if (this.activeTreeItem.viewpointinfo.vipo06 != "") {
        var jsonObject = JSON.parse(
          this.activeTreeItem.viewpointinfo.vipo06.replace(/'/g, '"')
        );
        EaBIM.view.restoreState(jsonObject);
      }
    },
    changeModel() {
      var model = this.modelList.find(
        (item) => item.mode01 == this.selectModelId
      );
      model.enterType = "yydh";
      model.path = model.mode09;
      model.showType = 1;
      model.type = 1;
      EaBIM.localServerModels(model);
    },
    openFile(url) {
      window.open(this.$store.state.baseUrl + url);
    },
    addToFormData(obj, formData, parentKey = "") {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          let value = obj[key];
          let fullKey = parentKey ? `${parentKey}[${key}]` : key;
          if (value !== null && value !== undefined) {
            if (Array.isArray(value)) {
              value.forEach((item, index) => {
                if (typeof item === "object") {
                  // this.addToFormData(item, formData, `${fullKey}[${index}]`);
                  formData.append(`${fullKey}[${index}]`, item);
                } else {
                  formData.append(`${fullKey}[${index}]`, item);
                }
              });
            } else if (typeof value === "object") {
              this.addToFormData(value, formData, fullKey);
            } else {
              formData.append(fullKey, value);
            }
          }
        }
      }
    },
    clickReply(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var formData = new FormData();
          this.addToFormData(this.replyForm, formData);
          formData.append("miid", this.activeTreeItem.id);
          formData.append("status", 1);
          formData.append("replylId", this.$store.state.uid);
          formData.append("modelid", this.modelId);
          ReplyModelissue(formData).then((res) => {
            this.$message.success("回复成功");
            this.GetModelissueList();
          });
          this.replyShow = false;
        } else {
          return false;
        }
      });
    },
    adminBtn(type) {
      if (type == 0) {
        this.$prompt("请输入内容", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            reply(value);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入",
            });
          });
      } else {
        this.$confirm("此操作关闭该问题, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            reply("已解决");
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      }

      const reply = (value) => {
        var formData = new FormData();
        formData.append("miid", this.activeTreeItem.id);
        formData.append("status", type);
        formData.append("content", value);
        formData.append("replylId", this.$store.state.uid);
        formData.append("modelid", this.modelId);
        ReplyModelissue(formData).then((res) => {
          this.$message.success("操作成功");
          this.GetModelissueList();
        });
      };
    },
    cascaderChange(val) {
      if (this.ysviewList.find((item) => item.vipo01 == val).vipo10 == 1) {
        this.$message.error("请选择正确的视点");
        this.form.viewid = null;
      }
    },
    // 发起问题表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.xid = this.$store.state.xid;
          this.form.creatuser = this.$store.state.uid;
          this.form.modelId = this.modelId;
          this.issueShow = false;
          this.addTreeShow = false;
          AddorUpdataModelissue(this.form).then((res) => {
            this.$message.success("操作成功");
            this.form = this.$options.data().form;
            this.GetModelissueList();
          });
        } else {
          return false;
        }
      });
    },
    // 获取项目成员
    GetProjectuserList() {
      GetProjectuser({
        xid: this.$store.state.xid,
        searchword: "",
      }).then((res) => {
        this.userList = res.Data;
      });
    },
    // 获取视点列表
    GetViewPointList() {
      GetViewPoint({
        modelid: this.modelId,
        modeltype: 1,
        selectId: "",
        userId: "",
      }).then((res) => {
        this.ysviewList = res.Data;
        this.viewList = this.buildTree(res.Data, "vipo01", "vipo03");
      });
    },
    /**
     * 将扁平数据构建成树形结构，并清理空的 children 字段
     * @param {Array} flatData - 扁平数据数组
     * @param {String} idField - 节点唯一标识字段名
     * @param {String} parentIdField - 父节点标识字段名
     * @returns {Array} 树形结构数组
     */
    buildTree(flatData, idField = "sysNo", parentIdField = "parentId") {
      const map = {};
      const tree = [];

      // 构建映射关系
      flatData.forEach((item) => {
        map[item[idField]] = { ...item, children: [] };
      });

      // 构建树结构
      flatData.forEach((item) => {
        const id = item[idField];
        const parentId = item[parentIdField];
        if (parentId && map[parentId]) {
          map[parentId]["disabled"] = map[parentId].children.length
            ? false
            : true;
          if (map[id].hasOwnProperty("vipo10") && map[id].vipo10 == 1) {
            map[id]["disabled"] = true;
          } else {
            map[id]["disabled"] = false;
          }
          map[parentId].children.push(map[id]);
        } else {
          if (map[id].hasOwnProperty("vipo10") && map[id].vipo10 == 1) {
            map[id]["disabled"] = true;
          }
          tree.push(map[id]);
        }
      });

      // 清理空的 children 字段
      function removeEmptyChildren(node) {
        if (node.children && node.children.length === 0) {
          delete node.children;
        } else if (node.children) {
          node.children.forEach(removeEmptyChildren);
        }
      }

      tree.forEach(removeEmptyChildren);

      return tree;
    },
    // 获取问题管理列表
    GetModelissueList(uid = "") {
      this.activeTreeItem ? "" : (this.showInfo = false);
      GetModelissue({
        xid: this.$store.state.xid,
        modelId: this.modelId,
        searchword: this.issueSearch,
        status: this.issueType,
        ishomepage: 0,
      }).then((res) => {
        this.yszNodes = res.Data;
        this.yszNodes.forEach((item) => {
          item.isParent = item.isfolder == 1 ? true : false;
        });
        this.activeTreeItem
          ? (this.activeTreeItem = this.yszNodes.find(
            (item) => item.id === this.activeTreeItem.id
          ))
          : "";

        this.zNodes = this.buildTree(res.Data, "id", "treeid");
      });
    },
    toggleCollapse() {
      // 切换面板展开/收起状态
      this.isCollapsed = !this.isCollapsed;
    },
    getData(data) {
      if (data && data != "") {
        this.activeTreeItem = this.yszNodes.find((item) => item.id === data);
        if (this.activeTreeItem && this.activeTreeItem.isfolder == 1) {
          this.showInfo = false;
        } else {
          this.showInfo = true;
          this.GetXtModelVersionsListFC();
        }
      }
    },
    GetXtModelVersionsListFC() {
      GetXtModelVersionsList({
        mid: this.modelId,
      }).then((res) => {
        this.modelList = res.Data;
        this.selectModelId = this.modelList[0].mode01 || "";
      });
    },
    addZtree(data) {
      this.form = this.$options.data().form;
      if (
        data &&
        this.yszNodes.find((item) => item.id === data).isfolder == 0
      ) {
        this.$message.error("请选择文件夹");
        return false;
      }
      this.form.treeid = data || 0;
      this.form.isfolder = 1;
      this.addTreeShow = true;
    },
    async delZtree(ids) {
      ids = ids.split(",");
      for (let i = 0; i < ids.length; i++) {
        var res = await DelModelissue({
          delid: ids[i],
          user: this.$store.state.uid,
        });
        if (res.Code == 0) {
          this.$message.error(res.Message);
          break;
        } else {
          this.$message.success("删除成功");
        }
      }
      this.GetModelissueList();
    },
    editZtree(data) {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = data[key];
      });
      this.activeTreeItem = data;
      if (data.isfolder == 1) {
        this.addTreeShow = true;
      } else {
        this.GetViewPointList();
        this.issueShow = true;
      }
    },
  },
  watch: {
    modelId: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.GetModelissueList();
        }
      },
      deep: true,
    },
  },
  created() {
    this.GetProjectuserList();
  },
  mounted() {
    this.container = document.getElementById("left1");
  },
};
</script>

<style scoped lang="less">
.drone-info-container {
  gap: 10px;
  position: absolute;
  left: 200px;
  align-items: flex-start;
  min-width: 330px;
  background-color: transparent;
  overflow: hidden;
  top: 15px;
  z-index: 2;
  .flexColumn {
    // justify-content: flex-start;
  }
  .zTreeDiv {
    height: 100%;
    width: 100%;
  }
  /deep/.ztree {
    min-height: 480px;
  }
}

.drone-info-container-list,
.drone-info-container-info {
  background-color: #ffffffa9;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 330px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2cafe2;
  padding: 10px;
  cursor: pointer;
  height: 40px;
  box-sizing: border-box;
  color: #fff;
}

.titles {
  display: flex;
  align-items: center;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.collapse-text {
  color: white;
  font-size: 14px;
}

.content {
  padding: 10px;
  height: 700px;
  .FCC {
    // width: 100%;
    justify-content: space-around;
    align-items: self-start;
  }
  // width: calc(100% - 20px);
  .el-radio {
    margin-right: 0px;
    // color: #fff!important;
    /deep/.el-radio__label {
      padding-left: 5px !important;
    }
  }
}

.drone-img {
  width: 100%;
  height: 180px;
  display: block;
  margin-bottom: 10px;
}

.drone-model {
  color: white;
  text-align: center;
  margin-bottom: 10px;
}

.info-block {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.info-block2 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  background-color: #0084ff26;
}

.info-item {
  text-align: center;
  padding: 10px 0;
  /* margin: 10px 0; */
}

.info-value {
  color: #00ccff;
  font-size: 20px;
  display: block;
  margin-bottom: 5px;
}

.info-label {
  color: white;
  font-size: 12px;
}

/* 动画样式 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.1s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
